module.exports = __webpack_public_path__ + "img/hr-tree-05-f-trunk.4e8d32e0.png";